<template>
  <div class="main">
    <div v-show="facecheck" class="facelayer">
      <img :src="faceimg" style="margin: 50px,auto;width: 300px;height: 300px;" />
      <van-button @click="checkface" class="btn">人脸验证</van-button>
      <div>{{ tishi }}</div>
    </div>
    <van-dialog
      v-model="dialogshow"
      show-cancel-button
      :beforeClose="beforeperjiaojuanClose"
    >
      <div class="jjclass">
        <div>已答题：{{doanswer}}</div>
        <div @click="choseanswer('no')">未答题：<span style="color:red;">{{undoanswer}}</span></div>
        <div >总上传图片数：{{imgsuptotal}}</div>
        <div >上传成功图片数：{{imgsupsucnum}}<van-button @click="sucimgs()">查看</van-button></div>
      </div>
    </van-dialog>
    <div
      v-show="dialogimgsshow"
      class="imgshowdiv"
    >
      <van-button @click="closeimgshow()">关闭显示</van-button>
      <div style="display: flex;flex-wrap: wrap;justify-content:center" >
        <div v-for="(uimg,i) in imgsupsucess" >
          <div v-html="'题目：'+uimg.examcont"></div>
          <img v-for="(img,m) in uimg.imagedata" :src="img.url" style="width: 100px;height: 100px;"></img>
        </div>
      </div>
    </div>
    <van-nav-bar
      right-text="交卷"
      left-arrow
      @click-left="back"
    >
      <template #title>
        <div class="title" @click="titleTap()">
          {{ type.text }}<van-icon name="arrow-down" color="#7d7e80" size="12" />
        </div>
      </template>
      <template #right>
        <van-icon name="clock" color="#7469F8" />
        <div v-html="dtime"></div>
      </template>
    </van-nav-bar>
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <div class="name-num" @click="popupshow">
      <p>{{title}}</p>
      <div><span>{{ curIndex + 1 }}</span>/{{ curTotal }}</div>
    </div>
<!--    <v-touch v-on:swipeleft="alterNum('next')" v-on:swiperight="alterNum('last')" >-->
    <div class="content">
      <!-- 单选题 -->
      <single-opt v-if="data[type.value].examtypeid == '1' " :multiple="false" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 多选题 -->
      <single-opt v-if="data[type.value].examtypeid == '2'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 判断题 -->
      <true-or-false v-if="data[type.value].examtypeid == '3'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].examtypeid == '4'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 问答题 -->
      <q-and-a v-if="data[type.value].examtypeid == '5'" @saveda="saveanswer" :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />
      <!-- 理解题 -->
      <comprehension v-if="data[type.value].examtypeid == '6'" @saveda="saveanswer" :paper-id="paperId" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 不定项选择题 -->
      <single-opt v-if="data[type.value].examtypeid == '7'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!--排序题 8-->
      <px-info v-if="data[type.value].examtypeid == '8'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].examtypeid == '9'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 固定题型以外都已问答题展示 -->
      <q-and-a v-if="parseInt(data[type.value].examtypeid==null || data[type.value].examtypeid=='' ? '0' : data[type.value].examtypeid) > 9" @saveda="saveanswer" :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />
    </div>
<!--    </v-touch>-->
    <!-- 题型 -->
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        title="题型"
        show-toolbar
        :columns="typeoption"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <van-tabbar v-model="active" active-color="#7d7e80">
      <van-tabbar-item icon="arrow-left" @click="alterNum('last')">上一题</van-tabbar-item>
      <van-tabbar-item icon="share" @click="prejiaojuan">交卷</van-tabbar-item>
      <van-tabbar-item icon="arrow" @click="alterNum('next')">下一题</van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="popshow" position="left" style=" width: 30%;height:100% ">
      <div style="display: flex;flex-direction: column;padding-left: 5px;padding-right: 5px;">
        <span style="margin-top: 6.25rem;">选择题目：</span>
        <van-button plain type="info" @click="choseanswer('yes')">已答题({{doanswer}})</van-button>
        <van-button plain type="danger" @click="choseanswer('no')">未答题({{undoanswer}})</van-button>
        <van-button plain type="default" @click="choseanswer('all')">全部</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import singleOpt from '../examonline/components/singleOpt'
  import TrueOrFalse from '../examonline/components/trueOrFalse.vue'
  import fillIn from '../examonline/components/fillIn.vue'
  import qAndA from '../examonline/components/qAndA.vue'
  import PxInfo from '../examonline/components/pxinfo.vue'
  import comprehension from '../examonline/components/comprehension.vue'
  import sf from '../../utils/somefun.js';
  import { Dialog } from 'vant';

  var timectrl = sf.tc;
  export default {
    components: {
      singleOpt,
      TrueOrFalse,
      fillIn,
      qAndA,
      comprehension,
      PxInfo
    },
    data() {
      return {
        type: {
          text: '单选题',
          value: 0
        },
        wdtype: 11111,
        wdtindex: 11111,
        curIndex: 0,
        curTotal: 0,
        active: 0,
        show: false,
        loading:true,
        typeoption: [],
        dialogimgsshow:false,
        dialogshow:false,
        imgsupsucess:{},
        imgsuptotal:0,
        imgsupsucnum:0,
        index:0,
        doanswer:0,
        undoanswer:0,
        ystime:0,
        isautojj: false,
        jiaojuaning: false,
        bbaractive: 0,
        isapp: false,
        isios: false,
        title: '',
        lxactive: 0,
        data: [{PaperInfotabList:[],examtypedesc:'',examtypeid:''}],
        paperinfo:{},
        lxdata: {},
        dtstarttime: '',
        dtstarttimes: '',
        kstarttime: '',
        exam_time: '',
        taskid: '',
        paperId: '',
        paperDesc: '',
        jjlx: '',
        kendtime: '',
        kendtimes: '',
        ksbj: '',
        jjsj: '',
        ssjj: '',
        kcmc: '',
        dtime: '',
        autotime: '',
        popshow: false,
        stksid: '',
        ca: 'all',
        ecsenum: 0,
        isecsc: 0,
        faceimg: require('../../assets/img/person.png'),
        isface: 0,
        facetime: 0,
        facecs: 0,
        facecheck: false,
        tishi: '',
      }
    },
    created() {
      localStorage.setItem('currentpath', this.$router.currentRoute.fullPath);

      let id = this.$route.params.id;
      //let data = localStorage.getItem('Token') + ',' + id;
      //this.$jtp('notifykaoshi', data, this.qieping);
      //  window.test = this.test;
      let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
      let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      this.isapp = isAndroid || isiOS;
      this.isios = isiOS;
      document.onselectstart = function () {
        return false;
      };

      if (!id && this.stksid != '') {
        id = this.stksid;
      }
      let params = {
        stksid: id
      };
      this.stksid = id;
      let cs = localStorage.getItem(this.stksid + 'facetime');
      if (!cs) {
        localStorage.setItem(this.stksid + 'facetime', new Date().getTime());
      }
      let p = {id: this.stksid};
      localStorage.setItem('currentpathparams', JSON.stringify(p));

      let zthat = this;
      let data = {params: {stksid: this.stksid,pcorphone:'2'}}
      this.$ajax.get('/student/suitangks/studentpaper',data).then(function (rep) {
        if (rep.code == 500 || rep.code == 401) {
          zthat.$toast.fail(rep.msg);
          zthat.$router.push('/studentmain');
        } else {
          let that = {};
          rep = rep.data;
          zthat.dtstarttime = zthat.$moment(rep.dtstarttime).valueOf();
          zthat.dtstarttimes = rep.dtstarttime;

          zthat.title = rep.kcmc+"(总分:"+ rep.paperinfo.papervalue+"分)";
          zthat.kendtime = zthat.$moment(rep.kendtime).valueOf();
          zthat.kendtimes = rep.kendtime;

          // if (rep.paperinfo == undefined || rep.paperinfo.paperId == undefined || rep.paperinfo.paperId == '' || rep == undefined || rep.length === 0) {
          //   zthat.$toast.fail('试卷暂时不能进入考试！');
          //   zthat.back();
          // }
          //zthat.ecsenum = rep.paperinfo.ecsenum;
          //zthat.isecsc = rep.paperinfo.isecsc;
          //zthat.isface = rep.paperinfo.isface;
          //zthat.facetime = rep.paperinfo.facetime;
          zthat.paperinfo = rep.paperinfo;
          zthat.paperId = rep.paperinfo.stid;
          zthat.taskid = rep.taskid;
          zthat.kstarttime = rep.kstarttime;
          zthat.paperDesc = rep.paperdesc;
          zthat.ksbj = rep.ksbj;
          zthat.kcmc = rep.kcmc;
          zthat.ssjj = rep.ssjj;


          // if ('2' != rep.paperinfo.pcorphone) {
          //   zthat.$toast.fail('该试卷只支持PC端考试');
          //   zthat.back();
          // }
          if(zthat.ssjj=='Y')
          {
            zthat.$toast.fail('已交卷不能考试');
            zthat.back();
          }

          zthat.exam_time = rep.exam_time * 60 * 1000;
          zthat.ystime = rep.ystime * 60000;
          zthat.autotime = zthat.dtstarttime + zthat.exam_time < zthat.kendtime ? zthat.dtstarttime + zthat.exam_time + zthat.ystime : zthat.kendtime + zthat.ystime;
          zthat.data = rep.typeoption;
          for (let i = 0; i < zthat.data.length; i++) {
            zthat.typeoption.push({text:zthat.data[i].examtypedesc,value:i});
            //默认一个
            if(i==0){
              zthat.type.text=zthat.data[i].examtypedesc;
              zthat.type.value=i;
              zthat.curTotal = zthat.data[i].PaperInfotabList.length;
            }
          }

          // if (zthat.isface == '1' && zthat.facetime != undefined && zthat.facetime != '') {
          //   console.log('facecheck....', Number.parseFloat(zthat.facetime) * 60 * 1000);
          //   timectrl.addDurDo(
          //     zthat,
          //     function (now) {
          //       let cs = localStorage.getItem(this.ksmxid + 'facetime');
          //       if (Number.parseInt(cs) + Number.parseInt(this.facetime) * 60 * 1000 < now && this.facecs == 0) this.facecheck = false;
          //     },
          //     60 * 1000
          //   );
          // }
          timectrl.addDurDo(
            zthat,
            function (now) {
              if (this.autotime < now) {
                this.$toast.success('时间到，自动交卷中');
                this.isautojj = true;
                this.jjlx = "2";
                this.jaojuan();
              }
              this.dtime = this.autotime - now - 8 * 60 * 60 * 1000;
              this.dtime = this.$moment(this.dtime).format('HH:mm:ss');
            },
            1000
          );
        }
        zthat.loading = false
      });
    },
    methods: {
      calcActive() {
        this.curTotal = this.data[this.type.value].PaperInfotabList.length
      },
      aletrType(type) {
        if (type === 'next') {
          if (this.type.value < this.data.length && this.type.value != this.data.length-1) {
            this.curIndex = 0
            this.type.value++
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive();
          } else {
            this.$toast('没有更多')
          }
        }
        if (type === 'last') {
          if (this.type.value > 0) {
            this.type.value--
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive()
            this.curIndex = this.curTotal - 1
          } else {
            this.$toast('没有更多')
          }
        }

      },
      alterNum(type) {
        if (type === 'next') {
          if (this.curIndex < this.curTotal - 1) {
            this.curIndex++
          } else {
            // 进入下一题型
            this.aletrType(type)
          }
        }
        if (type === 'last') {
          if (this.curIndex > 0) {
            this.curIndex--
          } else {
            this.aletrType(type)
          }
        }
        this.saveanswer();
      },
      titleTap() {
        this.curIndex = 0
        this.show = true
      },
      dropdownChange() {

      },
      onConfirm(e) {
        this.type = e
        this.show = false
        this.calcActive()
      },
      onCancel() {

      },
      //将answer组装到PaperInfotabList
      checkface() {
        let data = '';
        this.$jtp('openCameraFace', data, this.getFace);
      },
      getFace(res) {
        this.face = res;
        this.tishi = '验证中.....';
        let data = new FormData();

        data.append('img', this.face);
        let that = this;
        this.$ajax
          .post('/upfile', data)
          .then(function(res) {
            that.checkfacebypath(res);
          })
          .catch(() => {
            that.tishi = '上传失败，请重新上传';
          });
      },

      facepass() {
        this.facecheck = false;
        this.tishi = '';
        this.facecs = this.facecs + 1;
        localStorage.setItem(this.stksid + 'facetime', new Date().getTime());
      },
      facefail() {
        this.$toast.fail('人脸验证未通过,再试');
        this.tishi = '人脸验证未通过,再试';
      },
      checkfacebypath(path) {
        this.tishi = '数据已上传，验证中....';

        let that = this;
        this.facepass();
        // this.$ajax({
        //   url: '?imgpath=' + encodeURIComponent(path),
        //   baseURL: '/api1/',
        //   method: 'get'
        // }).then(function(res) {
        //   that.tishi = res;

        //   let user = JSON.parse(localStorage.getItem('user'));

        //   if (user.xh && res.indexOf(user.xh) != -1) {
        //     that.facepass();
        //   } else if (user.sfzjh != undefined && user.sfzjh != '' && res.indexOf(user.sfzjh) != -1) {
        //     that.facepass();
        //   } else {
        //     that.facefail();
        //   }
        // });
      },
      paixuzuzhuang(optionarr, answerarr) {
        for (let i = 0; i < answerarr.length; i++) {
          for (let z = 0; z < optionarr.length; z++) {
            if (optionarr[z].optionid == answerarr[i]) {
              optionarr[z].xl = i + 1;
              break;
            }
          }
        }
      },
      back() {
        this.$router.push('/studentmain');
      },
      qieping(res) {
        // let data = JSON.parse(res);
        // data.ksmxid = this.ksmxid;
        // data.token = localStorage.getItem('Token');
        // let that = this;
        // this.$ajax.post('/qptj', data).then(function(res) {
        //   console.log('qiping:', res, that.isecsc, that.ecsenum);
        //   if (res.code == 200) {
        //     if (that.isecsc) {
        //       if (res.data > that.ecsenum) {
        //         let c = { message: '切屏太频繁 有作弊嫌疑！', duration: 5000 };
        //         that.$toast.success(c);
        //       }
        //     }
        //   }
        // });
      },
      async tjanswerinfo() {
        this.doanswer = 0;
        this.undoanswer = 0;
        this.imgsuptotal = 0;
        this.imgsupsucess = [];
        this.imgsupsucnum = 0;
        for (let i = 0; i < this.data.length; i++) {
          for (let j = 0; j < this.data[i].PaperInfotabList.length; j++) {
            if (!sf.isEmpty(this.data[i].PaperInfotabList[j].examansws) && this.data[i].PaperInfotabList[j].examansws != null) {
              this.doanswer++;
              //检查图片视频音频是否上传成功
              if (this.data[i].PaperInfotabList[j].examtypeid != "1" &&
                this.data[i].PaperInfotabList[j].examtypeid != "2" &&
                this.data[i].PaperInfotabList[j].examtypeid != "3" &&
                this.data[i].PaperInfotabList[j].examtypeid != "4" &&
                this.data[i].PaperInfotabList[j].examtypeid != "8") {
                let isimg=false;
                for (let m = 0; m < this.data[i].PaperInfotabList[j].examansws.length; m++) {
                  if (this.data[i].PaperInfotabList[j].examansws[m].url != undefined) {
                    this.imgsuptotal++;
                    if (!sf.isEmpty(this.data[i].PaperInfotabList[j].examansws[m].url)) {
                      this.imgsupsucnum++;
                      isimg = true;
                    }
                  }
                }
                if(isimg)
                {
                  this.imgsupsucess.push({examcont:this.data[i].PaperInfotabList[j].examcont,imagedata:this.data[i].PaperInfotabList[j].examansws})
                }
              }
            } else {
              if (this.data[i].PaperInfotabList[j].examtypeid != "6") {
                this.undoanswer++;
                this.wdtype = i;
                this.wdtindex = j;
              }
            }
            if (!sf.isEmpty(this.data[i].PaperInfotabList[j].ljttabList) && this.data[i].PaperInfotabList[j].ljttabList != null) {
              for (let l = 0; l < this.data[i].PaperInfotabList[j].ljttabList.length; l++) {
                if (!sf.isEmpty(this.data[i].PaperInfotabList[j].ljttabList[l].examansws) && this.data[i].PaperInfotabList[j].ljttabList[l].examansws != null) {
                  this.doanswer++;
                  let isimg=false;
                  //检查理解图片视频音频上传
                  if (this.data[i].PaperInfotabList[j].ljttabList[l].examtypeid != "1" &&
                    this.data[i].PaperInfotabList[j].ljttabList[l].examtypeid != "2" &&
                    this.data[i].PaperInfotabList[j].ljttabList[l].examtypeid != "3" &&
                    this.data[i].PaperInfotabList[j].ljttabList[l].examtypeid != "4" &&
                    this.data[i].PaperInfotabList[j].examtypeid != "8") {
                    for (let m = 0; m < this.data[i].PaperInfotabList[j].ljttabList[l].examansws.length; m++) {
                      if (this.data[i].PaperInfotabList[j].ljttabList[l].examansws[m].url != undefined) {
                        this.imgsuptotal++;
                        if (!sf.isEmpty(this.data[i].PaperInfotabList[j].ljttabList[l].examansws[m].url)) {
                          this.imgsupsucnum++;
                          isimg = true;
                        }
                      }
                    }
                    if(isimg)
                    {
                      this.imgsupsucess.push({examcont:this.data[i].PaperInfotabList[j].ljttabList[l].examCont,imagedata:this.data[i].PaperInfotabList[j].ljttabList[l].examansws})
                    }
                  }
                } else {
                  this.undoanswer++;
                  this.wdtype = i;
                  this.wdtindex = j;
                }
              }
            }
          }
        }
      },
      sucimgs(){
        this.dialogshow=false;
        this.dialogimgsshow=true;
      },
      closeimgshow(){
        this.dialogimgsshow=false;
      },
      beforeperjiaojuanClose(action, done){
        if(action === 'confirm') {
          this.jjlx = "1";
          this.jaojuan();
          this.$toast.success("交卷中....");
          done()
        } else if(action === 'cancel') {
          done() //关闭
        }
      },

      choseanswer: function(tj) {
        if(tj == 'no')
        {
          if(this.wdtindex!=1111 && this.wdtype !=1111)
          {
            this.type.value = this.wdtype
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive();
            this.curIndex = this.wdtindex;
          }
        }
        else
        {
          this.alterNum('next');
        }
      },
      popupshow: function() {
        this.popshow = true;
        this.tjanswerinfo();

      },
      async prejiaojuan() {
        if (this.jiaojuaning) {
          this.$toast.fail('正在交卷中，不要重复点击');
          return;
        }
        let timsg=await this.tjanswerinfo();
        this.dialogshow=true;
      },
      paramstr: function()
      {
        let params = {
          ystime: this.ystime,
          taskid: this.taskid,
          stid: this.paperId,
          kendtime: this.kendtimes,
          stksid: this.stksid,
          dtstarttime: this.dtstarttimes,
          exam_time: this.exam_time/60/1000,
          ksbj: this.ksbj,
          jjsj: new Date().getTime(),
          paperDesc: this.paperDesc,
          paperinfo: this.paperinfo,
          typeoption: this.data,
          kstarttime: this.kstarttime,
          kcmc: this.kcmc,
          ssjj: this.ssjj,
          lx: this.jjlx,
          ydt: this.doanswer,
          wdt: this.undoanswer,
          zts: this.doanswer+this.undoanswer,
          pcorphone:'2'
        };
        return params
      },
      jaojuan: function() {
        let that = this;
        let params = this.paramstr();
        this.$ajax.put('/student/suitangks/examstudentjj', params).then(function(req) {
          that.jiaojuaning = false;
          if ((req.code = 200)) {
            if (req.extime != undefined && req.extime>0) {
              that.$toast.success('你申请了延时' + req.extime + '分钟');
              that.ystime=req.extime*60000;
              that.autotime = that.dtstarttime + that.exam_time < that.kendtime ? that.dtstarttime + that.exam_time + that.ystime : that.kendtime+that.ystime;
            }else{
              timectrl.stop();
              that.$toast.success(req.msg);
              that.$router.push('/studentmain');
            }

          } else {
            that.$toast.fail(req.msg);
          }
        }).catch(function(){
          that.jiaojuaning=false;
          that.$toast.fail('交卷失败,重新再试！');
        });
      },
      saveanswer: function() {
        this.tjanswerinfo();
        let params = this.paramstr();
        let that = this;
        this.$ajax.put('/student/suitangks/examstudentredis', params).then(function(req) {
          if (req.code === 400) {
            that.$toast.fail(req.msg);
            that.$router.push("/kaoshi");
          }
        });
      }
    }
  }
</script>
<style lang="scss">
  .main{
    .title{
      i{
        margin-left: .1875rem;
      }
    }
    i.van-icon-clock{
      margin-right: .1875rem;
    }
    .name-num{
      margin: 0 .625rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: .0625rem dashed rgb(235, 234, 234);
      span{
        font-size: 1.875rem;
        color: #7469F8;
      }
    }
    .content{
      padding: 0 .625rem;
    }
  }
  .imgshowdiv{
    position: fixed;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;

    z-index: 555;
  }
  .facelayer {
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 999;
  }
  .jjclass{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/suitangexam/suitangexam.vue